import Phaser from 'phaser';
import { HIDDEN_BGM, PHASE_BGM } from '../../audio/PhaseBgm';
import { runtimeBus } from '../../app/runtimeBus';
import { AUDIO_ASSETS, audioSources, CHARACTER_ASSETS } from '../../game/assets/manifest';
import { prepareCharacterOutlines } from '../presentation/characterOutline';

export class BootScene extends Phaser.Scene {
  public constructor() {
    super('BootScene');
  }

  public preload(): void {
    runtimeBus.sendLoading(0);
    this.load.on('progress', (progress: number) => runtimeBus.sendLoading(progress));
    this.load.on('loaderror', (file: Phaser.Loader.File) => {
      runtimeBus.sendLoading(0, `画像を読み込めませんでした：${file.key}`);
    });
    CHARACTER_ASSETS.forEach((asset) => this.load.image(asset.key, asset.path));
    AUDIO_ASSETS.forEach((key) => this.load.audio(key, [...audioSources(key)]));
    PHASE_BGM.forEach((track, index) => this.load.audio(track.key, `assets/audio/bgm/phase-${index + 1}.mp3`));
    Object.values(HIDDEN_BGM).forEach(track => this.load.audio(track.key, track.path));
  }

  public create(): void {
    prepareCharacterOutlines(this.textures);
    runtimeBus.sendLoading(1);
    this.scene.start('GameScene');
  }
}
